module.exports = __webpack_public_path__ + "img/legend_color.6e6cf115.svg";